<template>
  <div class="box exercises" v-if="routerName != 'mobileUpload'" v-loading.fullscreen.lock="loading" >
    <el-container>
      <el-header class="headers">
        <Header @myReport="myReport" @myCenter="myCenter" :reportList="reportList"></Header>
      </el-header>
      <el-main>
        <div class="content">
          <status
            v-if="isStatus"
            :status="status"
            :key="key"
            :currentStatus="currentStatus"
          ></status>
          <div class="main">
            <ipad-status
              v-if="component.id == 'question'"
              :rightCircleStaff="rightCircleStaff"
              :moduleName="moduleName"
              :status="status"
               ref="ipadCircle"
            ></ipad-status>
            <el-card class="box-card">
              <transition name="fade" mode="out-in">
                <router-view :key="key"></router-view>
              </transition>
            </el-card>
          </div>
          <div class="charts center" v-if="component.id == 'question'">
            <RightCircle
              v-if="component.id == 'question'"
              ref="rightCircle"
              :estimatesTime="rightCircleStaff.estimatesTime"
              :rightRate="rightCircleStaff.rightRate"
              :currentPointNum="rightCircleStaff.currentPointNum"
              :totalPointNum="rightCircleStaff.totalPointNum"
              :isCancelTimeoutNotice="isCancelTimeoutNotice"
              @cancelTimeoutNotice="cancelTimeoutNotice"
            ></RightCircle>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { login, nextStep } from "@/api/base";
import Header from "@/components/Header";
import RightCircle from "@/components/RightCircle";
import Status from "@/components/Status";
import IpadStatus from "@/components/IpadStatus";
import videojs from "video.js";
import { formatTime } from "@/utils";
import {
  setTime,
  initSocketMsgData,
  getUserLocalData,
  getTime
} from "@/utils/auth";
export default {
  name: "HelloWorld",
  components: {
    Header,
    RightCircle,
    Status,
    IpadStatus
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      routerName: "", // 路由名称
      showTime: 0, // ipad 模式倒计时
      time: 0,
      isRouterAlive: true,
      centerDialogVisible: false, //弹窗
      loading: true,

      rightCircleStaff: {
        estimatesTime: 0, //预计时间
        rightRate: 0, //正答率
        currentPointNum: 0, //当前知识点数
        totalPointNum: 0 //总知识点数
      },

      reportList: [], // 我的报告项
      currentStatus: [], // 存储当前阶段

      isCancelTimeoutNotice: false,

      status: [],
      moduleName: "", //模块名称
      source: "", // 接收缓存数据更新页面
      isStatus:false,
    };
  },
  watch: {
   $route(to, from) {
      this.routerName = to.name;
    }
  },
  computed: {
    ...mapGetters([
      "qTime",
      "module",
      "showTimeoutNotice",
      "moduleStatus",
      "component",
      "stopTimer"
    ]),
    formatShowTime() {
      return formatTime(this.showTime);
    },
    formatTime() {
      return formatTime(this.estimatesTime);
    },
    key() {
      return this.$route.name !== undefined
        ? this.$route.name + new Date()
        : this.$route + new Date();
    }
  },
  mounted() {
    this.loading = false;
  },
  created() {
    this.loading = true;
    this.getAsideData(true);
    this.getNameFilter();
  },
  methods: {
    ...mapActions(["setQtime", "setTimeoutNotice"]),
    bindEvent() {
      const _this = this;
      window.onbeforeunload = function() {
        setTime({
          key: _this.qKey,
          value: _this.qTime
        });
      };
    },
    getNameFilter() {
      if(this.routerName){
        this.routerName = this.$route.name.toLowerCase();
      }
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    setTime() {
      this.time = this.qTime;
      if (this.timer) clearInterval(this.timer);
      this.timer = setInterval(() => {
        ++this.time;
        this.setQtime(this.time);
        this.showTime = this.time;
      }, 1000);
    },
    reload() {
      this.setTime();
      this.getAsideData();
    },
    myReport() {
      // alert("点击了报告");
    },
    myCenter() {},
    cancelTimeoutNotice() {
      this.isCancelTimeoutNotice = true;
    },
    getAsideData(isPageLoaded) {
      this.source = this.component.source

      if (this.source && this.component.id == "question") {
        //rightCircle
        this.rightCircleStaff.estimatesTime = this.source.questionInfo && this.source.questionInfo.estimatesTime || 0; //预计时间
        this.rightCircleStaff.rightRate = this.source.rightRate; //正答率
        this.rightCircleStaff.currentPointNum = this.source.currentPointNum; // 已学习知识点个数
        this.rightCircleStaff.totalPointNum = this.source.totalPointNum; // 总知识点数
      }
      this.status = this.moduleStatus && this.moduleStatus.sectionList;
      if(this.status && this.status.length>0){
        this.isStatus = true
      }

      if(this.moduleStatus){
        this.reportList = this.moduleStatus.doneReport;
        this.currentStatus = this.moduleStatus.current;
      }


      for (let i = 0; i < this.status.length; i++) {
        if (this.status[i].status == "1") {
          this.moduleName = this.status[i].moduleName;
        }
      }

      const userInfo = getUserLocalData();
      this.qKey = "" + userInfo.userId + userInfo.topicId + this.qId;
      this.$nextTick(() => {
        const time = getTime(this.qKey);
        // 不會跳過的時候 提交答案的時候 暫停計時
        let stopTimer = this.stopTimer;
        if (!stopTimer) {
          // 是否是首次进入或者刷新
          if (!isPageLoaded) {
            this.setQtime(time);
            this.$refs.ipadCircle && this.$refs.ipadCircle.setTime(0);
          } else {
            this.setQtime(this.source.spentTime || 0);
            this.$refs.ipadCircle && this.$refs.ipadCircle.setTime(this.source.spentTime || 0);
          }
          this.$refs.rightCircle && this.$refs.rightCircle.renderCircle();
        } else {
          if (isPageLoaded) {
            this.$refs.ipadCircle && this.$refs.ipadCircle.setTime3(this.source.spentTime || 0);
            this.$refs.rightCircle && this.$refs.rightCircle.renderCircle3();
          }
          this.$refs.rightCircle && this.$refs.rightCircle.pauseTimer();
          this.$refs.ipadCircle && this.$refs.ipadCircle.pauseTimer();
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '@/assets/css/theme/register.scss';
.box {
  .el-container{
    width: 100%;
    height: 100%;
    background: #FF7F69 url('~@/assets/css/theme/#{$theme-name}/imgs/bg.png') no-repeat center;
    background-size: 100% 100%;
    color: #fff;
  }
  .box-card {
    width: 960px;
    min-height: 600px;
    margin: 0 auto;
    position: relative;
  }
  .el-card {
    border-radius: 20px;
  }
  .el-card__body {
    padding: 40px;
  }
  .headers {
    color: $theme-text-color-white;
    font-size: 14px;
    text-align: center;
      .el-row {
        height: 60px;
      }
      &.el-header {
        padding: 0;
      }
  }
  .content {
    display: -webkit-flex;
    flex-direction: row;
    max-width: 1366px;
    height: 100%;
    margin: 0 auto;
    color: #302D27;
  }
  .charts {
    width: 203px;
  }
}
.exercises {
  .el-dialog {
    width: 930px !important;
    height: 590px;
    border-radius: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Home.vue